import React, { useState } from "react";

import AboutUsComponent from "../components/AboutUs/aboutUs";
import Container from "../components/Container";
import ContentTemplate from "../components/Layout/contentTemplate";
import { Context } from "../utils/store";
import Head from "next/head";
import IcoInfo from "../public/images/ico/ico-information.svg";
import IcoQuestion from "../public/images/ico/ico-question.svg";
import Layout from "../components/Layout";
import TheTeamComponent from "../components/TheTeam/theTeam";
import TopicHeader from "../components/TopicHeader";
import fetchRequestLibrary from "../utils/fetchRequestLibrary";
import loadDataFromApi from "../utils/fetch";
import { useContext } from "react";
import CustomHead from '../components/CustomHead';
export default function AboutUs({ 
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
    auboisVousInforment,
    teams
}) {
    const context = useContext(Context);
    return (
        <Context.Provider
            value={{
                ...context,
                activePage: "aboutUs",
                thematiques,
                breakingNews,
                cities,
                ephemeralChannels,
                liveData,
                medias,
                auboisVousInforment
            }}
        >
            <Layout>
                <Container>
                    <CustomHead title='A propos'/>
                    <ContentTemplate type={"aboutUs"}>
                        <TopicHeader topic={"A propos de nous"} type={"aboutUs"} />
                        <AboutUsComponent />
                        <TopicHeader topic={"L'équipe"} type={"theTeam"} />
                        <TheTeamComponent teams={teams}/>
                    </ContentTemplate>
                </Container>
            </Layout>
        </Context.Provider>
    );
}

export async function getServerSideProps(context) {
    const {
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
        auboisVousInforment,
    } = await fetchRequestLibrary();

    let teams = await loadDataFromApi(`${process.env.SOURCE_API}rest/2.0/categories/getTeamsMembers.php`,'POST')

    return {
        props: {
            thematiques,
            breakingNews,
            cities,
            ephemeralChannels,
            liveData,
            medias,
            auboisVousInforment,
            teams
        },
    };
}